import { combineReducers } from 'redux';
import received from '../screens/Received/reducers';
import sended from '../screens/Sended/reducers';
export default combineReducers({
  received,
  sended,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/StickyNotes/reducers/index.js
 **/